<template>
  <v-card class="elevation-12">
    <v-toolbar dark color="primary" style="height:60px;" height="60">
      <img src="/img/atlas-mobile.png" alt="avatar" />
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-alert :value="invalidCredentials" color="error">
        {{ $vuetify.t('$vuetify.app.invalidCredentials') }}
      </v-alert>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @keyup.native.enter="submit"
      >
        <v-text-field
          prepend-icon="person"
          name="login"
          label="Login"
          type="text"
          :rules="loginRules"
          v-model="data.username"
          class="login"
          required
        ></v-text-field>
        <v-text-field
          id="password"
          prepend-icon="lock"
          name="password"
          label="Password"
          type="password"
          :rules="passwordRules"
          v-model="data.password"
          class="password"
          required
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn
            color="green darken-1"
            :loading="loading"
            dark
            block
            :disabled="!valid"
            @click="submit()"
            name="loginButton"
            >{{ $vuetify.t('$vuetify.app.login') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 class="text-xs-center pt-4 pb-3">
          <router-link to="/password/email" style="text-decoration: none;">{{
            $vuetify.t('$vuetify.app.forgotPassword')
          }}</router-link>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',
  components: {},
  props: {
    source: String
  },
  data: () => ({
    drawer: null,
    valid: true,
    loading: false,
    title: process.env.VUE_APP_SHORT_NAME,
    login: '',
    loginRules: [v => !!v || 'Login is required'],
    password: '',
    passwordRules: [v => !!v || 'Password is required'],
    tile: null,
    invalidCredentials: false,
    data: {
      username: null,
      password: null
    }
  }),

  computed: {
    ...mapGetters({
      getActiveCall: 'calls/getActiveCall'
    })
  },

  methods: {
    ...mapActions({
      loginAction: 'root/login',
      setLayout: 'root/setLayout',
      attachAuthHeader: 'root/attachAuthHeader',
      readCalls: 'calls/readCalls'
    }),

    submit() {
      this.loading = true
      if (this.$refs.form.validate()) {
        this.invalidCredentials = false
        this.loginAction({ data: this.data })
          .then(response => {
            this.setLayout('app-layout')
            this.attachAuthHeader(this.$axios)

            this.readCalls().then(() => {
              var route = _.isEmpty(this.getActiveCall)
                ? 'callsList'
                : 'activeCall'
              this.loading = false
              this.$router.push({ name: route })
            })
          })
          .catch(() => {
            // Reset form and validate to show error
            this.invalidCredentials = true
            this.$refs.form.reset()
            this.$refs.form.validate()
            this.loading = false
          })
      }
    }
  }
}
</script>
